<template>
    <el-dialog title="选择案例" top="30px" :visible.sync="visible" width="800px" :close-on-click-modal="false">
        <el-row type="flex" style="margin-top: -20px" justify="space-between">
            <div></div>
            <div>
                <el-input
                    size="small"
                    style="width: 300px; margin-right: 10px"
                    v-model="query.search_keyword"
                    placeholder="案例名称"
                    clearable
                    suffix-icon="el-icon-search"
                    @keyup.enter.native="handleSearch"
                />
                <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
            </div>
        </el-row>
        <ListPage
            ref="listPage"
            :search="false"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
            @selection-change="handleSelectionChange"
        >
            <template slot="columns">
                <el-table-column type="selection" width="50" align="center"></el-table-column>
                <el-table-column label="序号" align="center" type="index" width="80" />
                <el-table-column label="案例标题" align="center" prop="name" />
                <el-table-column label="分类" align="center" prop="category.name" />
                <el-table-column label="时间" align="center" prop="create_time" width="160" />
            </template>
        </ListPage>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { list } from "@/api/case/list";
import listMixin from "@/mixins/list";
export default {
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        lang: {
            type: String,
            default: "zh",
        },
    },
    data() {
        return {
            query: {
                search_keyword: "",
            },
            visible: false,
            loading: false,
            options: [],
            ids: [],
            ids_d: [],
            picks: [],
            names: [],
        };
    },
    watch: {
        value(val) {
            this.picks = val;
        },
    },
    mixins: [listMixin],
    methods: {
        open() {
            this.visible = true;
            this.search();
        },
        close() {
            this.visible = false;
        },
        search() {
            this.loading = true;
            const params = {
                ...this.query,
                lang: this.lang,
            };
            list(params).then(({ code, result, msg }) => {
                if (code === 200) {
                    this.tableData = result.data;
                    this.total = result.total;
                    this.setChecks();
                } else {
                    this.$message.error(msg);
                }
                this.loading = false;
            });
        },
        handleSelectionChange(val) {
            this.ids = val.map((x) => x.uuid);
            this.names = val;
            this.ids_d = this.tableData.filter((x) => this.ids.indexOf(x.uuid) === -1).map((x) => x.uuid);
            this.merge();
        },
        merge() {
            this.ids.forEach((x) => {
                if (!this.picks.find((n) => n.uuid == x)) {
                    this.picks.push(this.names.find((n) => n.uuid == x));
                }
            });
            this.ids_d.forEach((x) => {
                if (this.picks.find((n) => n.uuid == x)) {
                    this.picks = this.picks.filter((y) => y.uuid !== x);
                }
            });
        },
        setChecks() {
            this.tableData.map((x) => {
                if (this.picks.find((n) => n.uuid == x.uuid)) {
                    this.$nextTick(() => {
                        this.$refs.listPage.getTableRef().toggleRowSelection(x, true);
                    });
                } else {
                    this.$nextTick(() => {
                        this.$refs.listPage.getTableRef().toggleRowSelection(x, false);
                    });
                }
            });
        },
        handleConfirm() {
            if (this.picks.length === 0) {
                this.$message.warning("请选择案例");
                return;
            }
            this.$emit("pick", JSON.parse(JSON.stringify(this.picks)));
            this.visible = false;
        },
    },
};
</script>

<style></style>
